const transitionPageData = {
    title : "Transition to Net Zero",
    praghraphOne : "The Paris Agreement international treaty on climate change aims to limit the global temperature rise to 2°C maximum – though preferably 1.5°C - as compared with preindustrial levels. To achieve this long-term temperature goal, all countries should aim to achieve Net Zero greenhouse gas emissions in approximately the next three decades. We at SAB grasp clearly that addressing climate change is an urgent and complex challenge that demands a fundamental transformation of the global economy. We have therefore committed to setting our own operational Net Zero future target for 2035. Reaching this milestone requires drastic action in measuring, monitoring, and reducing emissions in energy use and other indirect emissions of the company. Alongside minimizing our environmental impact, we are also seeking new ways and new areas to lessen our footprint over the coming years.",
    // praghraphTwo : "Without leaving anyone behind and without negatively impacting the planet, there is room for everyone to benefit from the dividends of a sustainable economy. Our role is to support the Kingdom’s vision, lift economic participation and build an inclusive economy that is mindful of SMEs and diverse customers. In addition to SAB’s role within the economy as a green and sustainable financier, we intend to play an influential role within the financial community. Our strategic partnership with HSBC uniquely positions us to bring ESG talent, knowledge and best practices into the financial ecosystem of Saudi Arabia. SAB also believes in advocacy by engaging in stakeholder forums such as the 2022 Global Climate Summit (Cop 27) held in Sharm El Sheikh, Egypt, which demonstrates our willingness to be part of unlocking sustainable economies.",
    sectionOne : {
        title : "2023 Highlights",
        gridOne : [
            {
                icon : {
                    name : "led.svg",
                    alt : "",
                },
                number : {
                    value : 69099385,
                    unit : "",
                },
                subtitle : <p>measured in Kwh</p>,
                nubmerTwo : {
                    value : 119772,
                    unit : "m",
                    sup: "3"
                    // unit: <sup>3</sup>
                }, 
                subtitleTwo : <p>water consumption</p>
            },
            {
                icon : {
                    name : "earth.svg",
                    alt : "",
                },
                number : {
                    value : 13200,
                    unit : "kg",
                },
                subtitle : <p>paper recycled</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            },
            {
                icon : {
                    name : "bottol.svg",
                    alt : "",
                },
                number : {
                    value : 44900,
                    unit : "kg",
                },
                subtitle : <p>waste produced</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            }
        ],
        gridTwo : [
            {
                icon : {
                    name : "document.svg",
                    alt : "",
                },
                number : {
                    value : 2760000,
                    unit : " paper statements"
                },
                subtitle : <p><b>as retail customers were</b> migrated to eStatements</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            },
            {
                icon : {
                    name : "governance.svg",
                    alt : "",
                },
                number : {
                    unit : "First KSA Bank"
                },
                subtitle : <p>to eliminate plastic straws and single-use plastic bottles across office buildings</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            }
        ],
        cardOne : {
            icon : {
                name : "recycle.svg",
                alt : "",
            },
            title : {
                value : 374926,
                unit : "kg recycled waste"
            },
            subtitle : "as part of 2022 pilot recycling programme, potentially saving:",
        }
    },
    sectionThree : [
        {
            colOne : {
                number : {
                    value : 6373,
                    unit : ""
                },
            },
            colTwo : "trees"
        },
        {

            colTwo : "landfill waste",
            colOne : {
                number : {
                    value : 937,
                    unit : <span>m<sup className="power-number">3</sup></span>
                },
            },
        },
        {
            colOne : {
                number : {
                    value : 9933287,
                    // unit : <span>m<sup className="power-number">3</sup></span>
                },
            },
            colTwo : "litres of water",
        },
        {
            // type : "two",
            colOne : {
                number : {
                    value : 2160593,
                    unit : <small style={{ fontSize : 24 }}> kWh energy</small>,
                },
            },
            colTwo : "equivalent"
        }
    ],
    sectionFour : {
        title : "Project Future: SAB’s new smart office ",
        subtitle : "Extending environmental sustainability in our operations has included refashioning our business premises for the sustainability transition. SAB’s new headquarters, which we aim to occupy in Q3 2023, epitomises the best in smart and green building elements. This 30-storey tower is digitally enabled so that technology drives an environmentally sustainable green building ecosystem. As a result, SAB’s new banking tower was awarded a LEED Gold certification, which is one of the most reputable green building certification programmes globally. Due to its environmentally superior design and construction, SAB’s new headquarter premises will offer numerous environmental gains, including:",
        cards : [
            {
                number : 28.47,
                title : "reduction in operational energy consumption",
                subtitle : "",
            },
            {
                number : 59.25,
                title : "reduction in water consumption for landscaping",
                subtitle : "achieved through the selection of water-efficient plant species and efficient irrigation",
            },
            {
                number : 54.3,
                title : "reduction in indoor water consumption",
                subtitle : "due to water-efficient fixtures",
            },
            {
                number : 54.6,
                title : "reduction in energy consumption for lighting",
                subtitle : "achieved through use of LED fixtures, sensor controls, and natural daylight"
            },
            {
                number : 30,
                title : "higher outdoor air flow",
                subtitle : "as building code recommended outdoor air for enhanced indoor air quality",
            },
            {
                number : null,
                title : "Ozone friendly refrigerants",
                subtitle : "used with low global warming potential and zero ozone depletion potential",
            },
            {
                number : null,
                title : "Low volatile organic compound material",
                subtitle : "used to reduce harmful emissions and improve occupant wellbeing"
            }
        ],
        paragraphOne : "It was important to us that the construction process itself be as environmentally friendly as possible, and we are proud to have achieved the following:",
        cardsTwo : [
            {
                number : 28,
                title : "Recycled content",
                subtitle : "in our procured construction materials to date",
            },
            {
                number : 49.4,
                title : "locally-sourced materials",
                subtitle : "from regional suppliers within 500 miles of project",
            },
            {
                number : 70,
                title : "of electricity usage ",
                subtitle : "is compensated towards Renewable Energy Certificates",
            },
            {
                number : 75,
                title : "of construction waste was recycled",
                subtitle : "Metal, wood, concrete, paper, and plastic waste sent to recycling centres",
            }
        ],
        paragraphTwo : "*These efficiencies are calculated on an annual basis",
        paragraphThree : "For customers and employees, its state-of-the-art office spaces are inspired by sustainability without compromising on the best-of-breed ICT infrastructure needed for a modern workplace."
    }
}

export default transitionPageData;